// #region Imports
import React, { useEffect, useState, useRef, useCallback } from 'react';
import { buildProdutoPartial } from '../../../pages/Produtos/produtos-utils';
import './ProdutoCrud.scss';
// #endregion

export default function ProdutoCrud({ open, onClose, onSave, editing }) {
  // #region Estado
  const [form, setForm] = useState(buildProdutoPartial());
  const [saving, setSaving] = useState(false);
  const overlayRef = useRef(null);
  const firstFieldRef = useRef(null);
  // #endregion

  // #region Efeitos
  useEffect(() => {
    if (open) {
      setForm(editing ? { ...editing } : buildProdutoPartial());
      if (firstFieldRef.current) firstFieldRef.current.focus();
    }
  }, [open, editing]);
  const onKeyDown = useCallback((e) => { if (e.key === 'Escape') onClose(); }, [onClose]);
  useEffect(() => {
    if (!open) return;
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [open, onKeyDown]);
  // #endregion

  // #region Early return
  if (!open) return null;
  // #endregion

  // #region Handlers
  function handleChange(e) {
    const { name, value, type } = e.target;
    setForm(f => ({ ...f, [name]: type === 'number' ? value : value }));
  }
  async function handleSubmit(e) {
    e.preventDefault();
    setSaving(true);
    try {
      await onSave({
        ...form,
        id: form.id != null ? form.id : null,
        preco_venda: Number(form.preco_venda),
        estoque_atual: Number(form.estoque_atual),
        estoque_min: Number(form.estoque_min),
      });
      onClose();
    } finally { setSaving(false); }
  }
  function handleOverlay(e) { if (e.target === overlayRef.current) onClose(); }
  // #endregion

  // #region Render
  return (
    <div className="crud-overlay" ref={overlayRef} onMouseDown={handleOverlay} role="dialog" aria-modal="true">
      <div className="crud-modal" role="document">
        <form onSubmit={handleSubmit} className="crud-form">
          <h3>{editing ? 'Editar Produto' : 'Novo Produto'}</h3>
          <div className="form-grid">
            <div className="fg-item">
              <label htmlFor="f-nome">Nome *</label>
              <input id="f-nome" name="nome" ref={firstFieldRef} value={form.nome} onChange={handleChange} required />
            </div>
            <div className="fg-item">
              <label htmlFor="f-marca">Marca</label>
              <input id="f-marca" name="marca" value={form.marca} onChange={handleChange} />
            </div>
            <div className="fg-item">
              <label htmlFor="f-unidade">Unidade Medida</label>
              <input id="f-unidade" name="unidade_medida" value={form.unidade_medida} onChange={handleChange} />
            </div>
            <div className="fg-item">
              <label htmlFor="f-preco">Preço Venda</label>
              <input id="f-preco" name="preco_venda" type="number" min="0" step="0.01" value={form.preco_venda} onChange={handleChange} required />
            </div>
            <div className="fg-item">
              <label htmlFor="f-est-atual">Estoque Atual</label>
              <input id="f-est-atual" name="estoque_atual" type="number" min="0" value={form.estoque_atual} onChange={handleChange} required />
            </div>
            <div className="fg-item">
              <label htmlFor="f-est-min">Estoque Mínimo</label>
              <input id="f-est-min" name="estoque_min" type="number" min="0" value={form.estoque_min} onChange={handleChange} required />
            </div>
            <div className="fg-item">
              <label htmlFor="f-validade">Validade</label>
              <input id="f-validade" name="validade" type="date" value={form.validade} onChange={handleChange} />
            </div>
            <div className="fg-item">
              <label htmlFor="f-lote">Lote</label>
              <input id="f-lote" name="lote" value={form.lote} onChange={handleChange} />
            </div>
            <div className="fg-item fg-span-2">
              <label htmlFor="f-desc">Descrição</label>
              <textarea id="f-desc" name="descricao" value={form.descricao} onChange={handleChange} rows={3} />
            </div>
          </div>
          <div className="crud-actions">
            <button type="button" onClick={onClose}>Cancelar</button>
            <button type="submit" className="btn-primary" disabled={saving}>{saving ? 'Salvando...' : 'Salvar'}</button>
          </div>
        </form>
      </div>
    </div>
  );
  // #endregion
}